import * as React from "react";
import {
  Grid,
  Button,
  Box,
  TextField,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Alert,
  AlertTitle,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Card,
  CardContent,
  Divider,
  Chip,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import axiosInstance from "../../../../common/helpers/axios.instance";
import { useDispatch } from "react-redux";
import { finishLoader, startLoader } from "../../../../features/user/userSlice";
import "./appversion.css";

import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';

export default function AppVersion() {
  const [showModal, setShowModal] = React.useState(false);
  const [appVersion, setAppVersion] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [editingAppVersion, setEditingAppVersion] = React.useState(null);
  const [editingAppVersionId, setEditingAppVersionId] = React.useState(null);
  
  const androidVersionRef = React.useRef(null);
  const androidBuildNumberRef = React.useRef(null);
  const iosVersionRef = React.useRef(null);
  const iosBuildNumberRef = React.useRef(null);
  
  const fetchData = async () => {
    try {
      await axiosInstance
        .get(process.env.REACT_APP_BASE_API + "/appversioncheck")
        .then(res => {
          console.log(res.data.data);
          setAppVersion(res.data.data)
        });
    } catch (error) {
      console.log({ error });
    }
  }

  React.useEffect(() => {
    fetchData();
  }, [])

  const handleChange = () => {
    setEditingAppVersion(null);
    setEditingAppVersionId(null);
    
   
    if (androidVersionRef.current) androidVersionRef.current.value = "";
    if (androidBuildNumberRef.current) androidBuildNumberRef.current.value = "";
    if (iosVersionRef.current) iosVersionRef.current.value = "";
    if (iosBuildNumberRef.current) iosBuildNumberRef.current.value = "";
    
    setShowModal(true);
  }

  const submitNewAppVersion = async () => {

    if (!androidVersionRef.current || !androidBuildNumberRef.current || 
        !iosVersionRef.current || !iosBuildNumberRef.current) {
      alert("Gabim: Fushat nuk janë inicializuar!");
      return;
    }

    if (!androidVersionRef.current.value || !iosVersionRef.current.value) {
      alert("Ju lutem plotësoni të gjitha fushat!");
      return;
    }

    setLoading(true);

    let versionData = {
      androidVersion: androidVersionRef.current.value,
      androidBuildNumber: parseInt(androidBuildNumberRef.current.value) || 0,
      iosVersion: iosVersionRef.current.value,
      iosBuildNumber: parseInt(iosBuildNumberRef.current.value) || 0
    }

    try {
      if (editingAppVersionId) {
        await axiosInstance.put(
          `${process.env.REACT_APP_BASE_API}/appversioncheck/${editingAppVersionId}`,
          versionData
        );
      } else {
        await axiosInstance.post(
          process.env.REACT_APP_BASE_API + "/appversioncheck/add",
          versionData
        );
      }
      
      fetchData();
      setShowModal(false);
    } catch (error) {
      console.log({ error });
      alert("Gabim gjatë ruajtjes së versionit!");
      setLoading(false);
    } finally {
      setLoading(false);
      // setShowModal(false);
      setEditingAppVersion(null);
      setEditingAppVersionId(null);
    }
  }

  const handleEdit = (id) => {
    console.log(id);
    const selectedVersion = appVersion.find(item => item.id === id);
    
    if (!selectedVersion) {
      console.error("Version not found");
      return;
    }

    setEditingAppVersion(selectedVersion);
    setEditingAppVersionId(id);
    setShowModal(true);
    
    setTimeout(() => {
      if (androidVersionRef.current) {
        androidVersionRef.current.value = selectedVersion.androidVersion || "";
      }
      if (androidBuildNumberRef.current) {
        androidBuildNumberRef.current.value = selectedVersion.androidBuildNumber || "";
      }
      if (iosVersionRef.current) {
        iosVersionRef.current.value = selectedVersion.iosVersion || "";
      }
      if (iosBuildNumberRef.current) {
        iosBuildNumberRef.current.value = selectedVersion.iosBuildNumber || "";
      }
    }, 0);
  }
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "A jeni të sigurt që dëshironi të fshini këtë version? Ky veprim nuk mund të anulohet."
    );
    
    if (!confirmDelete) return;

    setLoading(true);
    try {
      await axiosInstance.delete(process.env.REACT_APP_BASE_API + "/appversioncheck/" + id);
      fetchData();
    } catch (error) {
      console.log({ error });
      alert("Gabim gjatë fshirjes së versionit!");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="app-version-container">
      <Box sx={{ maxWidth: 1200, margin: '0 auto', px: 2 }}>
        <Grid container spacing={3}>
          
          <Grid item xs={12}>
            <Typography 
              variant="h4" 
              component="h2" 
              sx={{ 
                color: 'primary.main',
                fontWeight: 'bold',
                textAlign: 'center',
                mb: 1,
                mt: 1
              }}
            >
              Menaxhimi i Versioneve të Aplikacionit Sportisti
            </Typography>
          </Grid>

         
          <Grid item xs={12} md={10} sx={{ margin: '0 auto' }}>
            <Card elevation={3} sx={{ borderTop: '4px solid #08C47C' }}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <InfoIcon sx={{ color: '#08C47C', fontSize: 30, mr: 1 }} />
                  <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#08C47C' }}>
                    Udhëzime për përdorim
                  </Typography>
                </Box>
                
                <Divider sx={{ mb: 0 }} />
                
                <List>
                  
                <ListItem sx={{ p: 0 }}>
                    <ListItemIcon>
                      <AddCircleIcon sx={{ color: '#08C47C' }} />
                    </ListItemIcon>
                    <ListItemText 
                      primary="Shto Version të Ri"
                      secondary="Kliko mbi butonin 'Shto Version të Ri' për të shtuar versionin e ri që sapo është publikuar në App Store dhe Play Store."
                      primaryTypographyProps={{ fontWeight: 'bold' }}
                    />
                  </ListItem>

                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon>
                      <EditIcon sx={{ color: '#1976d2' }} />
                    </ListItemIcon>
                    <ListItemText 
                      primary="Ndrysho Version"
                      secondary="Kliko mbi butonin 'Ndrysho' për të korrigjuar versionin nëse ka ndodhur gabim pas hedhjes në App Store dhe Play Store."
                      primaryTypographyProps={{ fontWeight: 'bold' }}
                    />
                  </ListItem>

                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon>
                      <DeleteIcon sx={{ color: '#d32f2f' }} />
                    </ListItemIcon>
                    <ListItemText 
                      primary="Fshij Version"
                      secondary="Kliko mbi butonin 'Fshij' për të hequr një version të gabuar ose të vjetër."
                      primaryTypographyProps={{ fontWeight: 'bold' }}
                    />
                  </ListItem>


                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon>
                      <NotificationsActiveIcon sx={{ color: '#ff9800' }} />
                    </ListItemIcon>
                    <ListItemText 
                      primary="Njoftimet"
                      secondary="Përdoruesit do të njoftohen automatikisht përmes një popup për të bërë update të aplikacionit."
                      primaryTypographyProps={{ fontWeight: 'bold' }}
                    />
                  </ListItem>
                </List>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={8} sx={{ margin: '0 auto' }}>
            <Alert severity="warning" sx={{ borderRadius: 2 }}>
              <AlertTitle sx={{ fontWeight: 'bold' }}>Kujdes!</AlertTitle>
              Sigurohuni që versioni është publikuar në të dyja platformet (iOS & Android) para se ta shtoni këtu.
            </Alert>
          </Grid>
        </Grid>
      </Box>

      <TableContainer
        component={Paper}
        sx={{ maxWidth: 1000, margin: "20px auto", boxShadow: 3 }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="app versions table">
          <TableHead>
            <TableRow sx={{ backgroundColor: "#08C47C" }}>
              <TableCell
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  borderRight: "1px solid #08C47C",
                }}
              >
                ID
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Versioni Android
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                BuildNumber Android
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Versioni iOS
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                BuildNumber iOS
              </TableCell>
              <TableCell
                sx={{ color: "white", fontWeight: "bold" }}
                align="center"
              >
                Veprimet
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
              {appVersion.length > 0 &&
                appVersion.map((item, index) => (
 
                  <TableRow
                    key={item.id}
                    sx={{
                      
                      ...(index === 0 && {
                        backgroundColor: "#e8f5e9 !important",
                        borderLeft: "4px solid #08C47C",
                        "& td": {
                          fontWeight: "600",
                          color: "#2e7d32",
                        },
                        "&:hover": { 
                          backgroundColor: "#c8e6c9 !important" 
                        },
                      }),
                   
                      ...(index > 0 && {
                        backgroundColor: "#fafafa",
                        opacity: 0.65,
                        "& td": {
                          color: "#9e9e9e",
                        },
                        "&:hover": { 
                          backgroundColor: "#f0f0f0",
                          opacity: 0.85,
                        },
                      }),
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                  <TableCell
                    sx={{ borderRight: "1px solid #08C47C" }}
                    component="th"
                    scope="row"
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      {index + 1}
                      {index === 0 && (
                        <Chip 
                          icon={<CheckCircleIcon sx={{ color: 'white !important' }} />}
                          label="Versioni Aktual" 
                          size="small" 
                          sx={{ 
                            backgroundColor: '#08C47C',
                            color: 'white',
                            fontWeight: 'bold',
                            fontSize: '0.7rem'
                          }} 
                        />
                      )}
                    </Box>
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #08C47C" }}>
                    {item.androidVersion}
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #08C47C" }}>
                    {item.androidBuildNumber}
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #08C47C" }}>
                    {item.iosVersion}
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #08C47C" }}>
                    {item.iosBuildNumber}
                  </TableCell>
                  <TableCell align="center">
                    <Box
                      sx={{ display: "flex", gap: 1, justifyContent: "center" }}
                    >
                      <Button
                        variant="contained"
                        color="info"
                        size="small"
                        onClick={() => handleEdit(item.id)}
                        // disabled={index === 0}
                        // title={index === 0 ? "Versioni aktiv nuk mund të ndryshohet" : ""}
                      >
                        Ndrysho
                      </Button>
                      <Button
                        variant="contained"
                        color="error"
                        size="small"
                        onClick={() => handleDelete(item.id)}
                        // disabled={index === 0}
                        // title={index === 0 ? "Versioni aktiv nuk mund të fshihet" : ""}
                      >
                        Fshij
                      </Button>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}

            <TableRow>
              <TableCell colSpan={6} align="center" sx={{ py: 2 }}>
                <Button
                  variant="contained"
                  onClick={() => handleChange()}
                  sx={{
                    backgroundColor: "#08C47C",
                    color: "white",
                    "&:hover": { backgroundColor: "#06a066" },
                  }}
                >
                  Shto Version te Ri
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      {showModal && (
        <Dialog fullWidth={false} open={true}>
          <DialogTitle color="primary">
            {editingAppVersionId ? "Ndrysho Versionin" : "Shto Version të Ri"}
          </DialogTitle>

          {loading && (
            <Stack
              sx={{ color: "grey.500" }}
              spacing={2}
              justifyContent="center"
              direction="row"
            >
              <CircularProgress color="success" />
            </Stack>
          )}

          <DialogContent>
            <Grid container>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12}>
                    <Box marginTop={1}>
                      <TextField
                        label="Android Version"
                        inputRef={androidVersionRef}
                        name="android-version"
                        fullWidth
                        type="text"
                        inputProps={{ pattern: "[0-9.]*$" }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box marginY={1}>
                      <TextField
                        type="number"
                        label="Android BuildNumber"
                        inputRef={androidBuildNumberRef}
                        name="android-buildnumber"
                        fullWidth
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box marginY={1}>
                      <TextField
                        label="iOS Version"
                        inputRef={iosVersionRef}
                        name="ios-version"
                        fullWidth
                        type="text"
                        inputProps={{ pattern: "[0-9.]*$" }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box marginY={1}>
                      <TextField
                        label="iOS BuildNumber"
                        inputRef={iosBuildNumberRef}
                        name="ios-buildnumber"
                        fullWidth
                        type="number"
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setShowModal(false)}
              variant="contained"
              color="error"
            >
              Mbyll
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => submitNewAppVersion()}
            >
              <span style={{ color: "white" }}>Ruaj</span>
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
}